/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from 'react';
import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'

import { Paper, Select, InputBase, IconButton, FormControl, MenuItem, Box, Chip, OutlinedInput, TextField } from '@material-ui/core'
import { Search, Clear, Label } from '@material-ui/icons'

import GroupIcon from '../Groups/GroupIcon';
import FieldIcon from '../Fields/FieldIcon';
import SingletonIcon from '../Singletons/SingletonIcon';
import { Autocomplete } from '@material-ui/lab';

const blue_theme = createMuiTheme({
    palette: {
      primary: {
        main: "#2296f3",
      },
      secondary: {
        main: "#dc014e",
      },
    },
});

const styles = theme => ({

})

class SearchBox extends Component {
    state = {
        search_entities : null,
        search_term : "",
    }

    makeSearch = () => {
        this.props.make_search(this.state.search_entities, this.state.search_term)
    }

    cancelSearch = () => {
        this.setState({...this.state, search_term : "", search_entities : []}, () => {
            this.props.cancel_search()
        })
    }

    

    render() { 
        console.log("search columns: ", this.props.columns)
        return (
            <div
                //variant = 'outlined'
                style = {{
                    width : '100%',
                    height : '100%',
                    display : 'flex',
                    flexDirection : 'row',
                    alignItems : 'center',
                }}
            >
                {/* <FormControl style={{marginRight:'5px'}}>
                    <Select
                        multiple
                        value={this.state.search_entities}
                        onChange={(event) => this.setState({...this.state, search_entities : event.target.value})}
                        renderValue={(selected) => (
                              selected.map((value) => (
                                <Chip key={value} label={value} size='small' color='primary' style={{marginRight:'2px'}} onDelete={searchColumnDelete}/>
                              ))
                          )}
                        >
                        {this.props.columns.map((column) => (
                            <MenuItem key={column} value={column}>
                                {column}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl> */}
                <div style={{ width : '50%', marginRight : '1px' }}>
                    <Autocomplete
                        multiple
                        options={this.props.columns}
                        size='small'
                        value={this.state.search_entities? this.state.search_entities:[]}
                        onChange={(event,newValue) => this.setState({...this.state, search_entities : newValue})}
                        ChipProps = {{
                            color : 'primary',
                            size : 'small'
                        }}
                        renderInput={(params) => (
                            <TextField
                            {...params}
                            label="Fields to search across"
                            variant = 'filled'
                            size = 'small'
                            />
                        )} 
                        style ={{backgroundColor : '#F5F5F5'}}  
                    />
                </div>
                <div style={{ width : '50%', padding : '10px', backgroundColor : '#F5F5F5' }}>
                    <InputBase 
                        style = {{width : '100%'}} 
                        placeholder = "Search"
                        value = {this.state.search_term}
                        onChange = {(event) => this.setState({...this.state, search_term : event.target.value})}
                        onKeyDown = {(event) => {
                            if (event.key === 'Enter' && this.state.search_term !== "") {
                                this.makeSearch()
                            }
                        }}
                        endAdornment = {this.state.search_term !== "" ? 
                        <IconButton size = 'small' onClick = {this.cancelSearch}>
                            <Clear/>
                        </IconButton> :
                        <IconButton size = 'small' onClick = {this.makeSearch}>
                            <Search/>
                        </IconButton>}
                    />
                    {/* {this.state.search_term !== "" ? 
                        <IconButton size = 'small' onClick = {this.cancelSearch}>
                            <Clear/>
                        </IconButton> :
                        <IconButton size = 'small' onClick = {this.makeSearch}>
                            <Search/>
                        </IconButton> 
                    } */}
                </div>
                
                
           </div>
        );
    }
}
 
export default withStyles(styles)(SearchBox);